import '../css/SkillCard.css'

const SkillCard = (prop) => {
  return (
    <div className="skill-card">
      <img className="skill-card-img" src={prop.img} alt="" />
      <h2 className="skill-card-title">{prop.title}</h2>
      <ul className="skill-card-list">
        {prop.content.map((item) => {
          return <li>{item}</li>
        })}
      </ul>
    </div>
  )
}

export default SkillCard
